import { AxiosResponse, isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export interface EFacturaFormState {
  typeCFE: number | null;
  serieCFE: string;
  number: number | null;
  amount: number | null;
  securityCode: string | null;
}

export const generateCfe = async (
  cfe: EFacturaFormState
): Promise<AxiosResponse> => {
  try {
    const res = await apiClient.post<AxiosResponse>(Endpoints.Cfe, {
      ...cfe,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error?.response?.data[0].errorMessage);
    }
    throw error;
  }
};
